import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { useDataState } from "../../../hooks/useDataState";
import {trackPromise} from "react-promise-tracker";
import LoadingIndicator from "../../../shared/LoadingIndicator";

import { useSharedListStyles } from "../../../shared/useSharedListStyles";
import DatacomponentTableView from "./DatacomponentTableView";
import http from "../../../shared/http-common";
import UserService from "../../../services/UserService";
import {useNavigate} from "react-router-dom";
import {buildRealmPath} from "../../../shared/routing";

const GetObjectDataByType = async (objecttype, type, realm, token) => {
    try {
        if(token && token !== 'Kein Token generiert!') {
            let formData = new FormData();
            formData.append("realm", realm);
            return await http.post(`/` + objecttype + `/` + type + `/list`, formData, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
        }
    } catch (e) {
        console.error(e);
    }
};


function Datacomponents() {
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);

    const dataCtx = useDataState();
    const dataObjects = dataCtx.objects;
    const setDataObjects = dataCtx.setObjects;
    const Datacomponents = dataCtx.components;
    const setDatacomponents = dataCtx.setComponents;
    const [administrativeObjects, setAdministrativeObjects] = useState([]);
    let navigate = useNavigate();

    const classes = useSharedListStyles();

    useEffect(()=>{
        if(!UserService.isLoggedIn()) {
            UserService.doLogout();
            navigate(buildRealmPath(realm, '/'))
        }
    }, []);

    useEffect(()=>{
        async function fetchData() {
            const dataObjects2 = await getMyData('realestateobject', 'site', realm, token);
            const administrativeObjects2 = await getMyData('administrativeobject', 'economicunit', realm, token);
            setDataObjects(dataObjects2);
            setAdministrativeObjects(administrativeObjects2);
        }
        fetchData();
    }, [realm, token, setDataObjects]);

    const getMyData = async (objecttype, type, realm, token) => {
        const result = await GetObjectDataByType(objecttype, type, realm, token);
        return result?.data;
    }

    return (
        <div>
            <div className={classes.katalogView}>
                <LoadingIndicator/>
                <div className={classes.btListe}>

                        <DatacomponentTableView
                            dataComponents={Datacomponents}
                            setDatacomponents={setDatacomponents}
                            realm={realm}
                            token={token}
                            dataObjects={dataObjects}
                            administrativeObjects={administrativeObjects}
                        />

                </div>

            </div>

        </div>
    );
}

export default Datacomponents;
